<template>
  <div
    class="register-two flex h-screen max-w-6xl mx-auto w-full flex-col lg:flex-row items-center justify-center gap-10 md:flex-row"
  >
    <div
      class="w-full lg:w-3/6 mx-auto flex flex-col gap-2 bg-white shadow-lg rounded-lg p-4 lg:p-8"
    >
      <NuxtLink
        to="/"
        class="flex flex-row items-center justify-between gap-2 cursor-pointer"
      >
        <div class="w-full flex items-center justify-start">
          <GlobalLogo class="h-12" @click="$router.push('/')" />
        </div>
        <div
          class="w-full flex flex-row items-center justify-between border border-orange-500 rounded gap-2 px-4 py-2"
        >
          <span class="text-orange-500">
            {{ $t("home") }}
          </span>
          <div class="landing-light-orange p-1 rounded">
            <Icon
              name="meteor-icons:arrow-up-right"
              class="size-5 text-orange-500"
            />
          </div>
        </div>
      </NuxtLink>
      <div
        class="flex flex-row items-center justify-between landing-light-orange rounded gap-2 text-nowrap mt-4 p-2"
      >
        <div class="w-full text-center">
          <span class="text-orange-500 font-bold text-sm">
            {{ $t("all_ready_account") }}
          </span>
        </div>

        <div
          class="w-full bg-orange-500 text-center cursor-pointer rounded my-1 py-1"
          @click="$router.push('/login')"
        >
          <span class="text-white text-sm font-medium">
            {{ $t("login_here") }}
          </span>
        </div>
      </div>

      <NuxtLink
        to="https://youtube.com/shorts/hFAwpoitao0"
        target="_blank"
        class="flex flex-row items-center justify-evenly landing-light-orange rounded gap-2 text-nowrap mt-4 p-2"
      >
        <span class="text-orange-500 font-bold text-sm text-wrap">
          {{ $t("opening_a_new_account_yt") }}
        </span>
        <Icon name="logos:youtube-icon" class="size-10 animate-pulse" />
      </NuxtLink>

      <div class="flex items-center justify-center mt-4 p-2">
        <GoogleSignin />
      </div>

      <div class="register-form mt-2">
        <SignupForm />
      </div>
    </div>
    <AuthLandingImage />
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user"
import { useForm } from "vee-validate"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const userStore = useUserStore()
const runtimeConfig = useRuntimeConfig()

const initialValues = computed(() => ({
  email: "",
  password: "",
  trustDevice: false,
}))

const {
  handleSubmit,
  isSubmitting,
  setFieldError,
  meta,
  values,
  errors,
  resetForm,
  setFieldValue,
  setErrors,
} = useForm({
  initialValues,
})

const router = useRouter()
const toaster = useToaster()
</script>

<style lang="scss">
.register-two {
  .register-form {
    .nui-input,
    .nui-select {
      border-width: 1px !important;
      border-color: theme("colors.orange.400") !important;
    }

    .nui-input:hover,
    .nui-select:hover {
      border-color: theme("colors.orange.700") !important;
    }

    .nui-input-icon {
      svg {
        color: theme("colors.orange.500") !important;
      }
    }

    .nui-checkbox {
      .nui-checkbox-inner {
        border-color: theme("colors.orange.500") !important;
      }
      .nui-icon-check {
        color: theme("colors.orange.500") !important;
      }
    }

    button {
      background-color: theme("colors.orange.500") !important;
    }
  }
}

.register-sticks {
  div:nth-child(1) {
    width: 60px;
    height: 3px;
    background-color: #f97316;
  }
  div:nth-child(2) {
    width: 40px;
    height: 2px;
    background-color: #f97316;
  }
}
</style>
